import Users from '../../schemas/public/Users';

/**
 * Utilisateur provisionné depuis Ximi : identité gérée dans Ximi, pas dans Stimul'In.
 * Source unique du garde-fou front (cf. .claude/migration/front-restrictions-ximi.md) :
 * pas d'édition de profil (dob incluse), pas d'invitations Bonne Étoile, pas de
 * suppression de compte côté Stimul'In.
 */
export const isXimiUser = (user?: Users | null): boolean => !!user?.ximiUserId;
